import Model from '../Model';
import BundleReleaseNotesModel from '../releaseNotes/BundleReleaseNotesModel';
import BundleSpecModel from './BundleSpecModel';

export default class BundleCreationModel extends Model {

	constructor(data) {
		super(data);

		// General Details
		this.name = data.name;
		this.version = data.version;
		this.description = data.description || '';
		this.release_notes = new BundleReleaseNotesModel({hasWritePermission: true});
		if (data.release_notes) {
			this.release_notes.contentTypeName = data.release_notes.syntax;
			this.release_notes.content = data.release_notes.content;
		}
		this.spec = new BundleSpecModel(data.spec || {});
		this.sign_immediately = data.sign_immediately;
	}

	build() {
		let buildResult = {
			name: this.name,
			version: this.version,
			description: this.description || '',
			dry_run: false,
			spec: this.spec.build(),
			sign_immediately: this.sign_immediately || false
		};
		if (this.release_notes.content) {
			buildResult.release_notes = {
				syntax: this.release_notes.contentType.code,
				content: this.release_notes.content
			};
		}
		return buildResult;
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/BundleCreationModel.js